const styles = theme => {
  return {
    accordion: {
      width: ' 100%',
      boxShadow: 'unset !important'
    },
    accordionSummary: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    accordionDetailsRoot: {
      padding: '8px',
      display: 'flex',
      flexDirection: 'column'
    },
    accordionIcon: {
      fontSize: '24px',
      paddingLeft: '5px',
      marginRight: '5px'
    },
    showMoreIcon: {
      fontSize: '16px'
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',
      marginBottom: '10px'
    },
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%'
    },
    quantity: {
      display: ' flex',
      justifyContent: 'space-between',
      width: '40%',
      paddingRight: '40px'
    },
    skuContainer: {
      display: 'flex',
      alignItems: 'baseline'
    },
    sku: {
      fontSize: '10px',
      paddingLeft: '10px'
    }
  };
};

export default styles;
